import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Input,
  Label,
  FormGroup,
  Alert
} from "reactstrap"
import rest from '../../lib/rest'
import rotas from '../../services/rotas'
import Loading from 'lib/loading'
import BootstrapTable from 'react-bootstrap-table-next'

const colunasItemVendas = [
  {
    dataField: 'produto_id',
    text: 'Cód',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'produto',
    text: 'Produto',
    align: 'left',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'itemvend_quant',
    text: 'Quantidade',
    align: 'center',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'itemvend_prtabela',
    text: 'Pr. Tabela',
    align: 'center',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'itemvend_prvenda',
    text: 'Pr. Vendido',
    align: 'center',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'itemvend_total',
    text: 'Total',
    align: 'center',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'cancelado',
    text: 'Cancelado',
    align: 'center',
    headerStyle: { cursor: 'default' },
    formatter: (cellContent, row) => {
      if (row.cancelado === 'Sim') {
        return (<div className="timeline-heading"><span className="badge badge-danger badge-pill m-0 aberto">{row.cancelado}</span></div>)
      }else{
        return (<div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">{row.cancelado}</span></div>)
      }
    }
  }
]

const FromVenda = ({ fechaModal, venda_nota_id, filial_id}) => {

  const [form, setForm]       = useState('')
  const [loading, setLoading] = useState(true)

  const editVendas = () => {
    let dados = {"venda_nota_id":venda_nota_id, "filial_id": filial_id}
    const url = rotas.vendas+'venda.php'
    try{
      let retorno = rest.post(url, dados)
      retorno.then(ret => {
        if (ret.success && ret.success === 'S') {
          if (ret.lista !== '') {

            if (ret.lista.nfce[0].status === 'A') {
              ret.lista.nfce[0].texto = 'Autorizada'
              ret.lista.nfce[0].class = ' badge badge-success badge-pill ml-3 aberto'
            }else if (ret.lista.nfce[0].status === 'T') {
              ret.lista.nfce[0].texto = 'Contingência'
              ret.lista.nfce[0].class = 'badge badge-warning badge-pill ml-3 aberto'
            }else if (ret.lista.nfce[0].status === 'C'){
              ret.lista.nfce[0].texto = 'Cancelada'
              ret.lista.nfce[0].class = 'badge badge-danger badge-pill ml-3 aberto'
            } else {
              ret.lista.nfce[0].texto = ''
              ret.lista.nfce[0].class = ''
            }

            setForm(ret.lista)
          }
        }
        setLoading(false)
      })
      return (true)
    }catch(err){
      console.log(err)
    }
  }

  const ListaFpagtos = () => {

    if (form.fpagtos && form.fpagtos.length > 0){
      return form.fpagtos.map((fpagto, index )=> {
        return (<Alert key={index} className="formaPagamento">{fpagto.tipo_pagamento}: {fpagto.valor}</Alert>)
      })

    }else{
      return (
        <>
        {form.dinheiro > 0 ? <Alert className="formaPagamento">Dinheiro: {parseFloat(form.dinheiro).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</Alert> : ''}
        {form.cartao > 0 ? <Alert className="formaPagamento">Cartão: {parseFloat(form.cartao).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</Alert> : ''}
        {form.cheque > 0 ? <Alert className="formaPagamento">Cheque: {parseFloat(form.cheque).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</Alert> : ''}
        {form.crediario > 0 ? <Alert className="formaPagamento">Crediário: {parseFloat(form.crediario).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</Alert> : ''}
        {form.outros > 0 ? <Alert className="formaPagamento">Outros: {parseFloat(form.outros).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</Alert> : ''}
        {form.parcelamento > 0 ? <Alert className="formaPagamento">Parcelamento: {parseFloat(form.parcelamento).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</Alert> : ''}
        {form.subsidio !=='R$ 0,00' ? <Alert className="formaPagamento">Subsidio: {form.subsidio}</Alert> : ''}
        </>
      )
    }
  }

  const VendaPBM = () => {
    if (form.pbm && form.pbm !== '') {
      return (
        <div className="dadosVendas card-mini mt-3">
          <Col>
            <span className="tag-card-mini">PBM</span>
            <div className="fPagamentos">
              <Alert className="datasus"> <strong> {form.pbm} </strong></Alert>
            </div>
          </Col>
        </div>
      )
    }
    return (<> </>)
  }

  const VendaAssefaz = () => {
    if (form.assefaz && form.assefaz !== '') {
      return(
        <div className="dadosVendas card-mini mt-3">
          <Col>
            <span className="tag-card-mini">Venda assefaz</span>
            <div className="fPagamentos">
              <Alert className="assefaz">{form.assefaz}</Alert>
            </div>
          </Col>
        </div>
      )
    }
    return (<> </>)
  }

  useEffect(() => {
    if(venda_nota_id && venda_nota_id !== ''){
      editVendas()
    }else{
      setForm('')
      setLoading(false)
    }
  },[]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    return (
      <Row>
        <Col md="9">
          <Row>

            <Col md='12'>
              <div className="dadosVendas card-mini">
                <Col>
                  <Row className="mb-2">
                    <Col className="pr-0">
                      <FormGroup className="mb-0">
                        <Input
                          disabled
                          id    = "formCnpj"
                          name  = "cnpj"
                          type  = "text"
                          value = {form.cnpj}
                        ></Input>
                      </FormGroup>
                    </Col>
 
                    <Col md="8" className="">
                      <FormGroup className="mb-0">
                        <Input
                          disabled
                          id    = "formFantasia"
                          name  = "fantasia"
                          type  = "text"
                          value = {form.fantasia}
                        ></Input>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </div>
            </Col>

            <Col md='12'>
              <div className="dadosVendas card-mini">
                <Col>
                  <span className="tag-card-mini">Dados da Venda</span>
                  <Row className="mb-2">
                    <Col className="pr-0">
                      <FormGroup className="mb-0">
                        <Label>Pré-Venda</Label>
                        <Input
                          disabled
                          id    = "formCab_venda"
                          name  = "venda_nota_id"
                          type  = "text"
                          value = {form.venda_nota_id}
                        ></Input>
                      </FormGroup>
                    </Col>
                    <Col md="1" className="pr-0">
                      <FormGroup className="mb-0">
                        <Label>Cupom</Label>
                        <Input
                          disabled
                          id    = "formCupom"
                          name  = "cupom"
                          type  = "text"
                          value = {form.cupom}
                        ></Input>
                      </FormGroup>
                    </Col>
                    <Col md="3" className="pr-0">
                      <FormGroup className="mb-0">
                        <Label>Data</Label>
                        <Input
                          disabled
                          id    = "formData"
                          name  = "data"
                          type  = "text"
                          value = {form.venda_data_hora}
                        ></Input>
                      </FormGroup>
                    </Col>
                    <Col className="pr-0">
                      <FormGroup className="mb-0">
                        <Label>Caixa</Label>
                        <Input
                          disabled
                          id    = "formCaixa"
                          name  = "caixa_id"
                          type  = "text"
                          value = {form.caixa_id}
                        ></Input>
                      </FormGroup>
                    </Col>
                    <Col md="4" className="">
                      <FormGroup className="mb-0">
                        <Label>Vendedor</Label>
                        <Input
                          disabled
                          id    = "formVendedor"
                          name  = "vendedor"
                          type  = "text"
                          value = {form.vendedor}
                        ></Input>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </div>
            </Col>

            <Col md='12'>
              <div className="dadosVendas card-mini">
                <Col>
                  <span className="tag-card-mini">cliente</span>
                  <Row className="mb-2">
                    <Col md="2" className="pr-0">
                      <FormGroup className="mb-0">
                        <Label>Cliente ID</Label>
                        <Input
                          disabled
                          id    = "formCliente_id"
                          name  = "cliente_id"
                          type  = "text"
                          value = {form.cliente_id}
                        ></Input>
                      </FormGroup>
                    </Col>
                    <Col md="7" className="pr-0">
                      <FormGroup className="mb-0">
                        <Label>Cliente</Label>
                        <Input
                          disabled
                          id    = "formCliente_cupom"
                          name  = "cliente_cupom"
                          type  = "text"
                          value = {form.cliente_cupom}
                        ></Input>
                      </FormGroup>
                    </Col>
                    <Col md="3" className="">
                      <FormGroup className="mb-0">
                        <Label>CPF</Label>
                        <Input
                          disabled
                          id    = "formCpf_cupom"
                          name  = "cpf_cupom"
                          type  = "text"
                          value = {form.cpf_cupom}
                        ></Input>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </div>
            </Col>

            <Col md='12'>
              <div className="dadosVendas card-mini">
                <Col>
                  <span className="tag-card-mini" >NFC-e    
                    <span className= {form.nfce ? form.nfce[0].class : ''}>
                      {form.nfce ? form.nfce[0].texto : ''}
                    </span>
                  </span>
                  <Row className="mb-2">
                    <Col md="2" className="pr-0">
                      <FormGroup className="mb-0">
                        <Label>Nº Nota</Label>
                        <Input
                          disabled
                          id    = "formNota"
                          name  = "nota_id"
                          type  = "text"
                          value = {form.nfce ? form.nfce[0].nf_id : ''}
                        ></Input>
                      </FormGroup>
                    </Col>
                    <Col md="1" className="pr-0">
                      <FormGroup className="mb-0">
                        <Label>Serie</Label>
                        <Input
                          disabled
                          id    = "formStatus"
                          name  = "status"
                          type  = "text"
                          value = {form.nfce ? form.nfce[0].serie_id : ''}
                        ></Input>
                      </FormGroup>
                    </Col>
                    <Col md="6" className="pr-0">
                      <FormGroup className="mb-0">
                        <Label>Chave</Label>
                        <Input
                          disabled
                          id    = "formChave"
                          name  = "chave"
                          type  = "text"
                          value = {form.nfce ? form.nfce[0].chave : ''}
                        ></Input>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="mb-0">
                        <Label>Data envio</Label>
                        <Input
                          disabled
                          id    = "formData_envio"
                          name  = "data_envio"
                          type  = "text"
                          value = {form.nfce ? form.nfce[0].data_nfce_envio : ''}
                        ></Input>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </div>
            </Col>

            <Col md="12">
              <div>
                <BootstrapTable
                  striped
                  id                = 'itemtable'
                  keyField          = 'item_venda_id'
                  data              = {form.item ? form.item: ''}
                  columns           = {colunasItemVendas}
                  noDataIndication  = "Nenhum registro encontrado"
                  rowEvents         = {{ onDoubleClick: (e, row, rowIndex) => {} }}
                  rowStyle          = {{ cursor: "pointer" }}
                />
              </div>
            </Col>
          </Row>
        </Col>
        
        <Col md='3'>
          <Col className="p-0">
            <FormGroup className="mb-0">
              <Input
                disabled
                id        = "formCancelado"
                name      = "cancelado"
                type      = "text"
                className = "inputStatus"
                value     = {form.cancelado === "Sim" ? "VENDA CANCELADA" : "VENDA ATIVA"}
                style     = {form.cancelado === "Sim" ? {background: '#ff7f7f', color: '#ffffff'}: {background: '#7ed6a5', color: '#ffffff'}}

              ></Input>
            </FormGroup>
          </Col>
          <div className="dadosVendas card-mini">
            <Col>
              <span className="tag-card-mini">Totais da venda</span>
              
              <Row className="mb-2 pt-2">
                <Col md='6' className="m-auto">
                  <Label>Total Pré-Venda</Label>
                </Col>
                <Col md='6'>
                  <Input
                    disabled
                    id        = "formVenda_total"
                    name      = "venda_total"
                    type      = "text"
                    className = {"font-weight-bold"}
                    value     = {form.venda_total}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='6' className="m-auto">
                  <Label>Desconto</Label>
                </Col>
                <Col md='6'>
                  <Input
                    disabled
                    id        = "formDesconto"
                    name      = "desconto"
                    type      = "text"
                    className = {"text-danger font-weight-bold"}
                    value     = {form.desconto}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='6' className="m-auto">
                  <Label>Subsídio</Label>
                </Col>
                <Col md='6'>
                  <Input
                    disabled
                    id        = "formSubsidio"
                    name      = "subsidio"
                    type      = "text"
                    className = {"text-success font-weight-bold"}
                    value     = {form.subsidio}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='6' className="m-auto">
                  <Label>Frete</Label>
                </Col>
                <Col md='6'>
                  <Input
                    disabled
                    id        = "formFrete"
                    name      = "frete"
                    type      = "text"
                    className = {"text-success font-weight-bold"}
                    value     = {form.frete}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='6' className="m-auto">
                  <Label>Devolução</Label>
                </Col>
                <Col md='6'>
                  <Input
                    disabled
                    id        = "formValor_devolucao"
                    name      = "valor_devolucao"
                    type      = "text"
                    className = {"text-danger font-weight-bold"}
                    value     = {form.valor_devolucao}
                  />
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md='6' className="m-auto">
                  <Label>Total Líquido</Label>
                </Col>
                <Col md='6'>
                  <Input
                    disabled
                    id        = "formVenda_recebido"
                    name      = "venda_recebido"
                    type      = "text"
                    className = {"text-info font-weight-bold"}
                    value     = {form.venda_recebido}
                  />
                </Col>
              </Row>
            </Col>
          </div>

          <VendaPBM />
          <VendaAssefaz />

          <div className="dadosVendas card-mini mt-3">
            <Col>
              <span className="tag-card-mini">Formas de Pagamento</span>
              <div className="fPagamentos">
                
                <ListaFpagtos />
                
              </div>
            </Col>
          </div>
        </Col>
       
        <Col className="text-center p-3">
          <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
        </Col>
      </Row>
    )
  }
}

export default FromVenda
